import {
  HTMLChakraProps,
  MenuItem,
  MenuIcon,
  useMenuItem,
  forwardRef,
} from '@chakra-ui/react';

import { CheckIcon } from '../Icons/General/CheckIcon';

interface DropdownItemOptions {
  /**
   * The icon to render before the menu item's label.
   * @type React.ReactElement
   */
  leftIcon?: React.ReactElement;

  /**
   * Renders styles and CheckIcon if selected
   * @type boolean
   */
  isSelected?: boolean;
}
export interface DropdownItemProps
  extends HTMLChakraProps<'button'>,
    DropdownItemOptions {}

export const DropdownItem = forwardRef<DropdownItemProps, 'button'>(
  (props, ref) => {
    const { leftIcon, isSelected, children, ...rest } = props;

    type HTMLAttributes = React.HTMLAttributes<HTMLElement>;
    const menuitemProps = useMenuItem(rest, ref) as HTMLAttributes;
    const shouldWrap = leftIcon;
    const _children = shouldWrap ? (
      <span style={{ pointerEvents: 'none', flex: 1 }}>{children}</span>
    ) : (
      children
    );

    const leftIconSpacing = '0.75rem';
    const checkIconSpacing = '0.75rem';

    return (
      <MenuItem
        textStyle="body-normal-medium"
        justifyContent="space-between"
        {...menuitemProps}
        textColor={props.isSelected ? 'primary.400' : 'neutral.500'}
        _focus={{ bg: 'primary.100' }}
        _active={{
          bg: 'primary.200',
        }}
      >
        {leftIcon && (
          <MenuIcon marginEnd={leftIconSpacing}>{leftIcon}</MenuIcon>
        )}
        {_children}
        {isSelected && (
          <MenuIcon marginStart={checkIconSpacing} marginEnd={checkIconSpacing}>
            <CheckIcon />
          </MenuIcon>
        )}
      </MenuItem>
    );
  },
);
